import { BehaviorSubject } from 'rxjs';

const bettingPreferenceModal$ = new BehaviorSubject(false);
const isFirstTime$ = new BehaviorSubject(false);

const displayBettingPreferenceModal = (isShow: boolean, isFirstTime?: boolean) => {
	bettingPreferenceModal$.next(isShow);
	isFirstTime$.next(isFirstTime ?? false);
}

export const bettingPreferenceService = {
	bettingPreferenceModal$: bettingPreferenceModal$.asObservable(),
	isFirstTime$: isFirstTime$.asObservable(),
	displayBettingPreferenceModal
};